module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "top": "130px"
    },
    attrs: {
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("\n          Search for existing user with accounts to merge\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [_c('form', {
    staticClass: "mb-xl top-margin form-row",
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback searchbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": "",
      "id": "search",
      "type": "text",
      "placeholder": "Search by first name, last name, or user email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSearchDisabled || _vm.isSearching
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.searchUsers()
      }
    }
  }, [(!_vm.isSearching) ? _c('span', [_c('em', {
    staticClass: "icon-magnifier pr-sm"
  }), _vm._v(" Search\n               ")]) : _c('span', [_c('em', {
    staticClass: "fa fa-spinner fa-spin pr-sm"
  }), _vm._v(" Searching...\n               ")])])])]), _vm._v(" "), (_vm.users.length === 0 && _vm.hasSearched && !_vm.isSearching) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg not-found-alert",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("No users with accounts found.\n           ")])])]) : _vm._e(), _vm._v(" "), (_vm.users.length > 0) ? _c('div', {
    staticClass: "table-responsive top-margin"
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("First name")]), _vm._v(" "), _c('th', [_vm._v("Last name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("User type")]), _vm._v(" "), _c('th', [_vm._v("Account(s)")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_vm._v(_vm._s(user.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getUserTypeLabel(user.userType)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.accounts.length))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-warning btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirmMergeUser(user)
        }
      }
    }, [_vm._v("\n                    Merge with this user\n                  ")])])])
  }))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-done",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("\n              Cancel\n            ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70f45beb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MergePartialUser.vue
// module id = 2170
// module chunks = 1